import { createEntityAdapter } from '@reduxjs/toolkit';
import { ClientEntity } from '../type';

const clientsAdapter = createEntityAdapter<ClientEntity>({
  selectId: client => client.id || '',
});

export default clientsAdapter;
